// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   cartItems: localStorage.getItem("cartItems")
//     ? JSON.parse(localStorage.getItem("cartItems"))
//     : [],
// };

// const cartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     addToCart: (state, action) => {
//       const newItem = action.payload;
//       const existingItemIndex = state.cartItems.findIndex(
//         (item) =>
//           item.shopId == newItem.shopId &&
//           item.categoryId == newItem.categoryId &&
//           item.tourId == newItem.tourId
//       );

//       if (existingItemIndex !== -1) {
//         const existingItem = state.cartItems[existingItemIndex];
//         // Check if date and time match
//         if (
//           existingItem.date == newItem.date &&
//           existingItem.timeSlot?.id == newItem.timeSlot?.id
//         ) {
//           // Same slot -> Merge quantity
//           existingItem.rideCount =
//             (parseInt(existingItem.rideCount) || 0) +
//             (parseInt(newItem.rideCount) || 0);
//         } else {
//           // Different slot -> Overwrite with new item
//           state.cartItems[existingItemIndex] = newItem;
//         }
//       } else {
//         // New tour item
//         state.cartItems.push(newItem);
//       }
//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },
//     removeFromCart: (state, action) => {
//       state.cartItems = state.cartItems.filter(
//         (item) => item.id !== action.payload
//       );
//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },
//     setCart: (state, action) => {
//       state.cartItems = action.payload;
//     },
//     clearCart: (state) => {
//       state.cartItems = [];
//       localStorage.removeItem("cartItems");
//     },
//   },
// });

// export const { addToCart, removeFromCart, setCart, clearCart } =
//   cartSlice.actions;

// export default cartSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const getInitialCart = () => {
  const savedCart = localStorage.getItem("cartItems");
  const savedTimestamp = localStorage.getItem("cartTimestamp");

  if (savedCart && savedTimestamp) {
    const isExpired = Date.now() - parseInt(savedTimestamp) > 3600000; // 1 hour in ms
    if (isExpired) {
      localStorage.removeItem("cartItems");
      localStorage.removeItem("cartTimestamp");
      return [];
    }
    return JSON.parse(savedCart);
  }
  return [];
};

const initialState = {
  cartItems: getInitialCart(),
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const newItem = action.payload;
      const existingItemIndex = state.cartItems.findIndex(
        (item) =>
          item.shopId == newItem.shopId &&
          item.categoryId == newItem.categoryId &&
          item.tourId == newItem.tourId
      );

      if (existingItemIndex !== -1) {
        // Replace existing item with the new one (latest selection)
        state.cartItems[existingItemIndex] = newItem;
      } else {
        // New tour item
        state.cartItems.push(newItem);
      }
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
      localStorage.setItem("cartTimestamp", Date.now().toString());
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.id !== action.payload
      );
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },
    setCart: (state, action) => {
      state.cartItems = action.payload;
    },
    clearCart: (state) => {
      state.cartItems = [];
      localStorage.removeItem("cartItems");
      localStorage.removeItem("cartTimestamp");
    },
  },
});

export const { addToCart, removeFromCart, setCart, clearCart } =
  cartSlice.actions;

export default cartSlice.reducer;
